// extracted by mini-css-extract-plugin
export default {"download":"download_download__pKOcG"};